// extracted by mini-css-extract-plugin
export default {"titleWrap":"index_titleWrap__3RxgI","title":"index_title__2jh3j","breadcrumb":"index_breadcrumb__2WVYP"};